import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { AppButton, Box, Text } from '@common-fe/common-fe';

import { ROUTES } from '@/common';
import { Modal } from '@/components';
import { useHistory } from '@/modules/core/hooks';

import FieldLevelAccessSetupForm from '../FieldLevelAccessSetup/FieldLevelAccessSetupForm';
import { useFieldLevelAccessSetupStore } from '../FieldLevelAccessSetup/stores';
import useGetLevelAccessByIdQuery from '../queries/useGetLevelAccessById.query';
import { IFieldLevelAccessSetup } from '../role.types';

interface Props {
  id: string;
  onChangeId: (value: string) => void;
}
const FieldLevelAccessCopyModal: React.FC<Props> = ({ id, onChangeId }) => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (id) {
      setVisible(true);
    }
  }, [id]);
  const { data, isLoading } = useGetLevelAccessByIdQuery({ id });

  const handleSetVisible = useCallback(
    (value: boolean) => {
      if (!value) {
        onChangeId('');
      }

      setVisible(value);
    },
    [onChangeId]
  );

  const history = useHistory();
  const setState = useFieldLevelAccessSetupStore((state) => state.setState);
  const handleSubmit = useCallback(
    (data: IFieldLevelAccessSetup) => {
      setState({
        ...data,
        id: '',
      });
      history.push(ROUTES.FIELD_LEVEL_ACCESS_SETUP);
    },
    [history, setState]
  );

  const defaultValues = useMemo(() => {
    if (!data) {
      return null;
    }
    const payload: IFieldLevelAccessSetup = {
      ...data,
      name: `${data?.name || ''} (2)`,
      copyLevelAccessId: id,
      isCopyLevelAccess: !!id,
    };
    return payload;
  }, [data, id]);

  return (
    <Modal
      testId="role-permissions-copy"
      visible={visible}
      onSetVisible={handleSetVisible}
      wrapperStyle={{ zIndex: 10000 }}
    >
      <FieldLevelAccessSetupForm
        key={data?.id}
        defaultValues={defaultValues}
        isLoading={isLoading}
        isModalMode
        isCopyMode
        onSubmit={handleSubmit}
        title={(
          <Text size="2xl" weight={700} margin={{ bottom: 'l' }} style={{ lineHeight: '32px' }}>
            Copy Properties
          </Text>
        )}
        footer={(
          <Box margin={{ top: 'l' }} direction="row" justify="end">
            <AppButton
              testId="role-copy_cancel"
              width="160px"
              buttonType="secondary"
              onClick={() => handleSetVisible(false)}
            >
              Cancel
            </AppButton>
            <Box margin={{ left: 's' }}>
              <AppButton
                testId="role-copy_apply"
                disabled={isLoading}
                width="160px"
                type="submit"
                buttonType="primary"
              >
                Next (1/2)
              </AppButton>
            </Box>
          </Box>
        )}
      >
      </FieldLevelAccessSetupForm>
    </Modal>
  );
};

export default FieldLevelAccessCopyModal;
